<template>
  <v-card>
    <div class="password-recovered security-card-content">
      <h2 class="check-email-title">
        {{ $i18n.t("passwordRecovered.title") }}
      </h2>

      <p class="check-email-text">
        {{ $i18n.t('passwordRecovered.text') }}
      </p>

      <NewButton
        :text="$i18n.t('base.return')"
        @on-click="$emit('resetSteps')"
      />

    </div>
  </v-card>
</template>

<script>
import NewButton from "../NewButton.vue";

export default {
  name: "PasswordRecovered",

  components: { NewButton },

};
</script>
